import { ReloadOutlined, SaveFilled, UploadOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import DataDiet from 'pages/diet/DataDiet';
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import { HAPUS_IFUNDEFINE } from 'services';
import _Api from 'services/Api/_Api';
import { Date_, TitleBar } from 'services/Forms/Forms';
import { Button_, Input_, Number_, Select_ } from 'services/Forms/FormsSatu';
import { msg } from 'services/Toastr/Notify/_Toastr';

function PemilihanDiet(pr) {

  const [getDietID, setgetDietID] = useState()

  const [data, setdata] = useState({})
  const FORM_ID = 2
  const KONSELING_ID = pr.konseling_id

  const getCombo = () => {
    _Api.get("/get-combo-form?form_id=" + FORM_ID + "&konseling_id=" + KONSELING_ID).then(res => {
      // setcombo(res)
      var dt = res.data.combo
      var rc = res.data.record
      setdata(rc)
      setlistDiet(res.data.listdiet)


      // frm.setFieldsValue(rc)

      var initfield = {}

      rc.map(gg => {
        if (gg.tipedata == "checkbox") {
          initfield.centang = { ...initfield.centang, [gg.fiel_fk]: gg.value == 1 }
        } else
          if (gg.tipedata == "textbox") {
            initfield[gg.fiel_fk] = gg.value
          } else
            if (gg.tipedata == "int") {
              initfield[gg.fiel_fk] = parseInt(gg.value)

              if (gg.fiel_fk == 'dietyangdiberikan') {
                // console.log(gg.fiel_fk)
                setgetDietID(gg.value)
              }


            } else
              if (gg.tipedata == "date") {
                initfield[gg.fiel_fk] = moment(gg.value)
              } else
                if (gg.tipedata == "multiple" && gg.value != undefined) {
                  var vlll = gg.value.split(",")
                  initfield[gg.fiel_fk] = vlll
                }
      })
      frm.setFieldsValue(initfield)

      setTimeout(() => {
        hitungBMR()
      }, 300);
    })

  }
  const [listDiet, setlistDiet] = useState([])


  const [frm] = Form.useForm();

  const dataFields = [
    { label: "Nama", field: "nama", disabled: true },
    { label: "Jenis Kelamin", field: "jeniskelamin_id", satuan: " L / P", disabled: true },
    // { label: "Tanggal Lahir", field: "tgllahir", satuan: "", tipe: "date", disabled: true },
    { label: "Usia", field: "umur", disabled: true, satuan: "tahun", disabled: true },
    { label: "Berat Badan", field: "bb", satuan: "kg", disabled: true, tipe: "int" },
    { label: "Tinggi Badan", field: "tb", satuan: "cm", disabled: true, tipe: "int" },
    { label: "BMR", field: "bmr", satuan: "kkal", disabled: true },
    { label: "Faktor Aktivitas", field: "faktor_aktivitas", tipe: "int" },
    { label: "Faktor Stress", field: "faktor_stress" },
    { label: "TEE", field: "tee", satuan: "kkal", disabled: true, },
  ];


  const simpanData = () => {
    // setloading(true)
    // console.log(val)
    // debugger
    frm.validateFields().then(val => {
      var pure = HAPUS_IFUNDEFINE(val)
      // delete cek.centang
      var obj = {
        konseling_id: KONSELING_ID,
        form_id: FORM_ID,
        // diet : ,
        data: {
          ...pure,
          // ...cheklist, 
          diet: pure.diet && pure.diet.length > 0 ? pure.diet.toString() : "",
          // diitsebelumnya: pure.diitsebelumnya && pure.diitsebelumnya.length > 0 ?  pure.diitsebelumnya.toString() :"",
        }
      }
      delete obj.data.centang
      _Api.post("simpan-form-konseling", obj).then(rs => {
        msg.auto(rs.data)
        // setloading(false)

      })
    }).catch(err => {
      // setloading(false)
      msg.error("Silahkan lengkapi data ")
    })
  }


  // const hitungUmur = () => {
  //   var tgl = frm.getFieldValue("tgllahir")
  //   var umur = dayjs  ().diff(tgl, 'year').toString()
  //   frm.setFieldsValue({ "usia": umur })

  //   hitungBMR()
  // }

  const hitungBMR = () => {

    const B12 = parseInt(frm.getFieldValue("tb") ?? 0)
    const B11 = parseInt(frm.getFieldValue("bb") ?? 0)
    const JK = frm.getFieldValue("jeniskelamin_id") ?? ""
    const Umur = parseInt(frm.getFieldValue("umur") ?? 0)

    var L0_3 = (0.167 * B11) + (1517.4 * B12 / 100) - 617.6
    var P0_3 = (16.25 * B11) + (1023.2 * B12 / 100) - 413.5
    var BMR0_3 = JK == "L" ? L0_3 : P0_3


    var L4_10 = (19.6 * B11) + (130.3 * B12 / 100) + 414.9
    var P4_10 = (16.97 * B11) + (161.8 * B12 / 100) + 371.2
    var BMR4_10 = JK == "L" ? L4_10 : P4_10

    // frm.setFieldsValue({ bmr4_10: BMR4_10 })

    var L11_18 = (16.25 * B11) + (137.2 * B12 / 100) + 515.5
    var P11_18 = (8.365 * B11) + (465 * B12 / 100) + 200
    var BMR11_18 = JK == "L" ? L11_18 : P11_18

    // hitung MBR
    var BMR = Umur <= 3 ? BMR0_3 : Umur <= 10 ? BMR4_10 : BMR11_18

    var TEE = BMR * (frm.getFieldValue("faktor_aktivitas") ?? 0) * (frm.getFieldValue("faktor_stress") ?? 0)


    frm.setFieldsValue({
      bmr0_3: BMR0_3.toFixed(2),
      L0_3: L0_3.toFixed(2),
      P0_3: P0_3.toFixed(2),
      P4_10: P4_10.toFixed(2),
      L4_10: L4_10.toFixed(2),
      bmr4_10: BMR4_10.toFixed(2),
      L11_18: L11_18.toFixed(2),
      P11_18: P11_18.toFixed(2),
      bmr11_18: BMR11_18.toFixed(2),
      bmr: BMR.toFixed(2),
      tee: TEE.toFixed(2),
    })


  }


  useEffect(() => {

    getCombo()
  }, [pr])

  return (
    <div>
      <Form form={frm} layout='horizontal'
        labelCol={{
          span: 6,
        }}
        wrapperCol={{
          span: 17,
        }}
      >
        <Row>
          <Col className='border p-2'>
            <Input_ label="Pemeriksa Lab/Klinik Penting" multiline name="pemeriksalab" />
            <Input_ label="Pengobatan Penting" multiline name="pengobatan" />
            <Input_ label="Dokter Yang Mengirim" name="dokterpengirim_id" />
            <Input_ label="Diagnosa" name="diagnosa" />
            <Select_ label="Diit" required name="diet" val="jenisdiet" caption="jenisdiet" multiple option={listDiet} />
            <div className='bg-info px-5 py-3 rounded'>
              <h4> Diet yang diberikan </h4>
              <Select_ size="large" required name="dietyangdiberikan" onChange={(e) => setgetDietID(e)} val="id" caption="jenisdiet" option={listDiet} />
            </div>

          </Col>

        </Row>
        {/* <Button_ label="Simpan" size="large" sm={3} block icon={<UploadOutlined />} onClick={simpanData} /> */}
      </Form>


      <div className='fixed-bawah'>
        <Row>
          <Button_ sm="2" icon={<UploadOutlined />} block title="Simpan" onClick={simpanData} />
          <Button_ color="orange" sm="2" icon={<ReloadOutlined />} block title="Refresh" onClick={getCombo} />

          {/* <Button_ sm="3" color="orange" icon={<UploadOutlined />} block title="Form Hidangan Sehari ( Recall 24 Jam )" /> */}
          <Col></Col>
        </Row>
      </div>

      {
        getDietID &&
        <DataDiet jenisdiet_id={getDietID} />
      }


    </div >
  )
}

export default PemilihanDiet
